// extracted by mini-css-extract-plugin
export default {"login":"Login_login__F4i8B","signContainer":"Login_signContainer__VxC++","title":"Login_title__09XtI","formContainer":"Login_formContainer__2BLY6"};